import { Box, MenuItem, Select, Typography } from "@mui/material";
import {
  ExportKeyDetailWrapper,
  ExportKeyTextWrapper,
  PasswordButtonGroups,
  PasswordInput,
  ViewPasswordButton,
  WalletAddressContainer,
} from "components/portfolio/styled";
import { CircleButton } from "components/CircleButton";
import { Chain, EVM_CHAINS } from "chainConfigs";
import { StyledExportKeyTextDrawer } from "components/portfolio/styled";
import { CrossChainConfig } from "v2/components/CrossChainDeposit/hocs/withCrossChainDeposit";
import { Close } from "@mui/icons-material";
import { useState } from "react";
import { useEffect, useRef } from "react";
import { RetroButton } from "components/RetroButton";
import { ReactComponent as PrivateIcon } from "assets/icons/private.svg";
import { ReactComponent as ShowIcon } from "assets/icons/eye.svg";
import { ReactComponent as HideIcon } from "assets/icons/eye-slash.svg";

const ExportPrivateKeyV1 = ({
  isOpen,
  close,
  onCopySuccess,
  sortedConfigs,
  selectedChain,
  setSelectedChain,
  handleCopy,
  keys,
}: {
  isOpen: boolean;
  close: () => void;
  onCopySuccess: () => void;
  sortedConfigs: CrossChainConfig[];
  selectedChain: Chain;
  setSelectedChain: (chain: Chain) => void;
  handleCopy: () => void;
  keys: Record<string, string | null>;
}) => {
  return (
    <StyledExportKeyTextDrawer anchor={"bottom"} open={isOpen} onClose={close}>
      <Box
        sx={{
          marginLeft: "auto",
          fontSize: "16px",
        }}>
        <CircleButton variant="white" onClick={close}>
          <Close fontSize="inherit" />
        </CircleButton>
      </Box>
      <ExportKeyDetailWrapper>
        <Box>
          <PrivateIcon height="140px" width="140px" />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            maxWidth: "495px",
            marginBottom: "16px",
            textAlign: "center",
          }}>
          <Typography variant="title-h1">YOUR PRIVATE KEY / RECOVERY PHRASE</Typography>
        </Box>
        <ExportKeyTextWrapper>
          <Typography variant="body-default" color="text.system-red">
            Never share your private key or recovery phrase to anyone.
          </Typography>
        </ExportKeyTextWrapper>
        <Select
          value={selectedChain}
          onChange={(event) => setSelectedChain(event.target.value as Chain)}
          sx={{ width: "100%", maxWidth: "495px", marginBottom: "16px" }}>
          {sortedConfigs.map((option, index) => {
            return (
              <MenuItem key={`cross-chain-modal-select-${index}`} value={option.id}>
                {option.networkName}
              </MenuItem>
            );
          })}
        </Select>
        <WalletAddressContainer>
          <PasswordInputs
            chain={selectedChain}
            password={EVM_CHAINS.includes(selectedChain) ? keys.ethereum! : keys[selectedChain]!}
          />
        </WalletAddressContainer>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            maxWidth: "495px",
          }}>
          <RetroButton variant="primary" onClick={handleCopy}>
            <Typography variant="title-h3" sx={{ padding: "12px 21.5px" }}>
              COPY
            </Typography>
          </RetroButton>
        </Box>
      </ExportKeyDetailWrapper>
    </StyledExportKeyTextDrawer>
  );
};

const PasswordInputs = ({ password, chain }: { password: string; chain: Chain }) => {
  const [isShowPassword, setShowPassword] = useState<boolean>(false);
  const passwordRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setShowPassword(false);
  }, [chain]);

  const handleShowPassword = () => {
    setShowPassword(!isShowPassword);
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          width: "100%",
        }}>
        <PasswordInput
          type={isShowPassword ? "text" : "password"}
          ref={passwordRef}
          disabled
          value={password}
        />
        <PasswordButtonGroups>
          <ViewPasswordButton
            $variant={isShowPassword ? "text" : "password"}
            onClick={handleShowPassword}>
            {isShowPassword ? (
              <ShowIcon width={16} height={16} />
            ) : (
              <HideIcon width={16} height={16} />
            )}
          </ViewPasswordButton>
          {/* {isCopied ? (
            <Typography color="text.system-green">✔</Typography>
          ) : (
            <IconButton sx={{ padding: "0px" }} onClick={handleCopyWalletAddress}>
              <CopyIcon width={16} height={16} />
            </IconButton>
          )} */}
        </PasswordButtonGroups>
      </Box>
    </>
  );
};

export { ExportPrivateKeyV1 };
